module.exports = __webpack_public_path__ + "media/images/mr5-feae07f7790b3ed61b7453a232df2bed.jpg";